/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import LegalPageLayout from './LegalPageLayout';
import { LEGAL_OWNER } from '@/lib/legalOwner';

const CookiePolicyPage = () => (
  <LegalPageLayout
    activeKey="cookie"
    title="Cookie Policy"
    subtitle="Informativa sui cookie e sulle tecnologie di tracciamento utilizzate."
    lastUpdated={LEGAL_OWNER.lastReview}
  >
    <h2>1. Titolare</h2>
    <p>
      {LEGAL_OWNER.fullName} — Codice Fiscale <code>{LEGAL_OWNER.fiscalCode}</code> — {LEGAL_OWNER.addressLine}.
      Contatti: <a href={`mailto:${LEGAL_OWNER.contactEmail}`}>{LEGAL_OWNER.contactEmail}</a>.
    </p>

    <h2>2. Cosa sono i cookie</h2>
    <p>
      I cookie sono piccoli file di testo che i siti visitati inviano al terminale dell'utente, dove
      vengono memorizzati per essere ritrasmessi al successivo accesso. Il sito vetrina di
      <strong> SanitàNexus</strong> utilizza esclusivamente cookie tecnici indispensabili.
    </p>

    <h2>3. Categorie di cookie utilizzati</h2>
    <table>
      <thead>
        <tr><th>Nome</th><th>Categoria</th><th>Finalità</th><th>Durata</th></tr>
      </thead>
      <tbody>
        <tr>
          <td><code>sn_auth</code></td>
          <td>Tecnico strettamente necessario</td>
          <td>Mantenere la sessione autenticata dell'utente (JWT httpOnly)</td>
          <td>7 giorni</td>
        </tr>
        <tr>
          <td><code>sn_theme</code></td>
          <td>Tecnico di preferenza</td>
          <td>Memorizzare la modalità chiara/scura selezionata</td>
          <td>12 mesi</td>
        </tr>
        <tr>
          <td><code>sn_a11y</code></td>
          <td>Tecnico di preferenza</td>
          <td>Salvare le preferenze di accessibilità (Senior Mode)</td>
          <td>12 mesi</td>
        </tr>
        <tr>
          <td><code>sn_lang</code></td>
          <td>Tecnico di preferenza</td>
          <td>Salvare la lingua preferita dell'interfaccia</td>
          <td>12 mesi</td>
        </tr>
      </tbody>
    </table>

    <h2>4. Cookie di profilazione e analytics</h2>
    <p>
      Il sito <strong>NON utilizza</strong> cookie di profilazione, tracciamento pubblicitario o
      analytics di terze parti (Google Analytics, Meta Pixel, ecc.). Non è pertanto necessaria alcuna
      raccolta di consenso ai sensi della Cookie Law.
    </p>

    <h2>5. Come gestire i cookie</h2>
    <p>
      L'utente può in qualsiasi momento eliminare i cookie tramite le impostazioni del proprio browser.
      La disabilitazione dei cookie tecnici (in particolare <code>sn_auth</code>) impedirà l'accesso
      alle aree riservate del sito.
    </p>
    <p>
      Guide ufficiali: <a href="https://support.google.com/chrome/answer/95647">Chrome</a>,
      {' '}<a href="https://support.mozilla.org/kb/enable-and-disable-cookies-website-preferences">Firefox</a>,
      {' '}<a href="https://support.apple.com/guide/safari/manage-cookies-sfri11471/mac">Safari</a>,
      {' '}<a href="https://support.microsoft.com/microsoft-edge">Edge</a>.
    </p>

    <h2>6. Cookie all'interno di un'installazione cliente</h2>
    <p>
      L'installazione del software presso una clinica potrebbe utilizzare cookie aggiuntivi per fini
      operativi (ID sessione paziente, preferenze operatore, ecc.). Tali cookie sono impostati
      esclusivamente dall'infrastruttura del cliente e non sono sotto controllo del Titolare della
      presente cookie policy.
    </p>

    <h2>7. Riferimenti normativi</h2>
    <ul>
      <li>Reg. UE 2016/679 (GDPR)</li>
      <li>D.lgs. 196/2003 novellato dal D.lgs. 101/2018</li>
      <li>Provvedimento del Garante Privacy del 10 giugno 2021 in materia di cookie</li>
    </ul>
  </LegalPageLayout>
);

export default CookiePolicyPage;
